import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class HeaderService{

    public title = new BehaviorSubject('Demo');

    constructor() { }

    setTitle(title) {
        this.title.next(title);
    }
}